import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AuthContext } from "../context/auth.context";
import { ProfileTariffSection } from "../components/ProfileTariffSection/ProfileTariffSection";
import type { JwtPayload } from "../types/auth";
import "./Profile.scss";

const ProfileInfoRow = ({ label, value }: { label: string; value: string }) => (
  <div className="profile-info-row">
    <dt className="profile-info-label">{label}</dt>
    <dd className="profile-info-value">{value}</dd>
  </div>
);

export const Profile = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const payload = user as JwtPayload | null | undefined;
  const email = payload?.sub?.trim() || "—";

  return (
    <div className="profile-page">
      <div className="profile-container">
        <div className="profile-top-bar">
          <button type="button" className="profile-back" onClick={() => navigate("/")}>
            <ArrowLeft size={20} />
            <span>Назад</span>
          </button>
        </div>
        <h1 className="profile-title">Профиль</h1>

        <section className="profile-card" aria-label="Информация о пользователе">
          <h2 className="profile-card-title">Пользователь</h2>
          <dl className="profile-info-list">
            <ProfileInfoRow label="Email" value={email} />
          </dl>
        </section>

        <ProfileTariffSection />
      </div>
    </div>
  );
};
